<template>
  <div :class="s.container" v-sound>
    <button :class="s.backButton" v-on:click="hideModal">戻る</button>

    <div :class="s.imageArea">
      <img v-if="item.image_url" :class="s.itemImage" :src="item.image_url" alt="商品画像" />
      <img v-else :class="s.itemImage" src="/img/menu/no_image.png" alt="商品画像" />
    </div>

    <div :class="s.infoArea">
      <div :class="s.itemInfo">
        <div :class="s.itemName">
          <p v-html="item.label"></p>
        </div>

        <!-- バリエーション選択 -->
        <div v-if="hasVariants" :class="s.variantSelector">
          <div :class="s.variantLabel">サイズを選択してください</div>
          <div :class="s.variantButtons">
            <button
              v-for="variant in item.variants"
              :key="variant.id"
              :class="[s.variantButton, { [s.selected]: selectedVariant && selectedVariant.id === variant.id }]"
              @click="selectVariant(variant)"
            >
              {{ variant.label }}
            </button>
          </div>
        </div>

        <div :class="s.itemPrice">
          <p v-if="currentPrice !== 0">
            {{ Math.round(currentPrice / 1.1).toLocaleString() }}円
                  <span :class="s.taxIncludedPrice">(税込{{ currentPrice.toLocaleString() }}円)</span>
          </p>
        </div>
        <div :class="s.itemDescription">
          <p v-if="item.description" :class="{ 'long-text': item.description.length > 10 }" v-html="item.description"></p>
        </div>
      </div>
      <div :class="s.itemQuantity">
        <div :class="s.itemQuantityLabel"> <p>数量</p>
        </div>
        <div :class="s.quantityControl">
          <button @click="decreaseQuantity"><i class="fa-solid fa-minus"></i></button>
          <input type="text" v-model.number="quantity" readonly /> <button @click="increaseQuantity"><i class="fa-solid fa-plus"></i></button>
        </div>
        <button :class="s.cartButton" @click="addToCart">カートに入れる</button>
      </div>
    </div>
  </div>
</template>

<script>
// ... (script部分は変更なし)
import { mapState } from 'vuex';

export default {
  props: {
    data: {
      require: true,
    },
  },
  data() {
    return {
      item: {},
      quantity: 1,
      selectedVariant: null,
    };
  },
  computed: {
    ...mapState(['user', 'cart', 'helper']),
    isReadySubmit() {
      return Boolean(this.items.every((item) => item.value || item.name === 'building'));
    },
    hasVariants() {
      return this.item.variants && this.item.variants.length > 0;
    },
    currentPrice() {
      if (this.selectedVariant) {
        return this.selectedVariant.price;
      }
      return this.item.price;
    },
  },
  created() {
    this.item = this.data.item || {};
    // デフォルトバリエーションを選択
    if (this.hasVariants) {
      this.selectedVariant = this.item.variants.find((v) => v.is_default) || this.item.variants[0];
    }
  },
  methods: {
    hideModal(payload) {
      this.$store.dispatch('modal/contents/hideModal', payload === 'update' ? payload : null, { root: true });
    },

    selectVariant(variant) {
      this.selectedVariant = variant;
    },

    increaseQuantity() {
      this.quantity += 1;
    },
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity -= 1;
      }
    },

    addToCart() {
      // バリエーションがある場合は選択されたバリエーションを使用
      const itemToAdd = this.selectedVariant || this.item;
      const displayLabel = this.selectedVariant
        ? `${this.selectedVariant.label}`
        : this.item.label;

      const existingItem = this.cart.items.find((cartItem) => cartItem.id === itemToAdd.id);
      if (existingItem) {
        for (let i = 0; i < this.quantity; i += 1) {
          this.addQuantity(existingItem.id);
        }
        this.hideModal();
      } else {
        const args = {
          id: itemToAdd.id,
          quantity: this.quantity,
          price: itemToAdd.price,
          label: displayLabel,
          name: itemToAdd.name,
          menus: this.item.menus,
        };
        this.$store.dispatch('cart/addCart', args, { root: true });
        this.hideModal();
      }
    },

    addQuantity(id) {
      this.$store.dispatch('cart/addQuantity', id, { root: true });
    },

  },
};
</script>

<style lang="scss" module="s">
.container {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: '游明朝', YuMincho, 'Hiragino Mincho ProN', Meiryo, sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 20px;
}

.backButton {
  position: absolute;
  top: 0%;
  left: 0%;
  background-color: #f0f0f0;
  color: #333;
  font-weight: bold;
  font-size: 1rem;
  padding: 8px 15px;
  border: 1px solid #333;
  border-radius: 5px;
  cursor: pointer;
  z-index: 10;
}

.backButton:hover {
  background-color: #e0e0e0;
}

.imageArea {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 100%;
  margin-bottom: 3vh;
}

.itemImage {
  height: 45vh;
  width: auto;
  object-fit: contain;
  border-radius: 20px;
}

.infoArea {
  margin-top: 0px;
  display: flex;
  align-items: center;
  width: 90%;
  max-height: 20vh;
}

.itemInfo {
  display: flex;
  flex-direction: column;
  width: 60%;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 20px;
}

.itemName {
  font-size: calc(100% + 0.5rem);
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
  line-height: 1.2;
  white-space: pre-wrap;
}

.itemPrice {
  font-size: calc(100% + 0.3rem);
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.taxIncludedPrice {
  font-size: 0.8em;
}

.itemDescription {
  font-size: calc(100% + 0.3rem);
  color: #333;
  margin-bottom: 0px;
  font-weight: bold;
  white-space: pre-wrap;
}

.itemDescription .long-text {
  /* 親要素から継承したフォントサイズに対して85%の大きさにします */
  font-size: 50% !important;
}

.itemQuantity {
  display: flex;
  flex-direction: column;
  width: 40%;
  align-items: center;
  justify-content: center;
}

.itemQuantityLabel {
  font-size: 1.1rem;
  color: #333;
  font-weight: normal;
  margin-bottom: 8px;
}

.quantityControl {
  display: flex;
  align-items: center;
  height: 45px;
  border: 2px solid #333;
  border-radius: 5px;
  margin-bottom: 20px;
  width: fit-content;
}

.quantityControl button {
  width: 45px;
  height: 100%;
  font-size: 1.5rem;
  background-color: #f0f0f0;
  color: #333;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantityControl button:hover {
  background-color: #e0e0e0;
}

.quantityControl button:first-child {
  border-right: 2px solid #333;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.quantityControl button:last-child {
  border-left: 2px solid #333;
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.quantityControl input {
  width: 60px;
  height: 100%;
  text-align: center;
  font-size: 1.3rem;
  font-weight: bold;
  border: none;
  background-color: #fff;
  color: #333;
  pointer-events: none;
}

.cartButton {
  width: auto;
  padding: 12px 30px;
  font-weight: bold;
  background-color: #B03A2E;
  color: #FFFFFF;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  white-space: nowrap;
}

.cartButton:hover {
  background-color: #9a3025;
}

.variantSelector {
  width: 100%;
  margin-bottom: 15px;
}

.variantLabel {
  font-size: 1rem;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}

.variantButtons {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.variantButton {
  padding: 10px 20px;
  font-size: 0.95rem;
  font-weight: bold;
  background-color: #f0f0f0;
  color: #333;
  border: 2px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.variantButton:hover {
  background-color: #e0e0e0;
  border-color: #999;
}

.variantButton.selected {
  background-color: #B03A2E;
  color: #FFFFFF;
  border-color: #B03A2E;
}

.variantButton.selected:hover {
  background-color: #9a3025;
  border-color: #9a3025;
}

@media (max-width: 768px) {
  .container {
    padding: 10px;
  }
  .backButton {
    /* 位置はrelativeの中で絶対配置なので、モバイルでも左上でOKだが微調整 */
    top: 5px;
    left: 5px;
    padding: 6px 12px;
  }
  .imageArea {
    height: auto; /* 高さを自動に */
    max-height: 200px; /* 最大高さを設定 */
    width: 100%;
    margin-top: 40px; /* 戻るボタンと被らないように余白を追加 */
  }
  .itemImage {
    height: auto; /* 高さを自動に */
    max-height: 180px; /* 最大高さを設定 */
  }
  .infoArea {
    flex-direction: column;
    width: 100%;
    max-height: none; /* 高さを自動に */
    margin-top: 10px;
  }
  .itemInfo {
    width: 100%;
    margin-bottom: 10px; /* itemQuantityとの間に少しスペース */
  }
  .itemQuantity {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>
